import React from 'react';
import { TLabels, TReportHeader, TReportTypeCode } from '@@config/report';
import ReportBasicInfo from '@@components/ReportBasicInfo/ReportBasicInfo';
import ReportSupplementals from '@@components/ReportSupplementals/ReportSupplementals';
import ReportSupplemental from '@@components/ReportSupplemental/ReportSupplemental';

type TReportHeaderProps = {
    readonly header: TReportHeader;
    readonly reportTypeCode: TReportTypeCode;
    readonly reportNumber: string | number;
    readonly primaryCTA?: URL | undefined;
    readonly labels: TLabels;
    // Props needed for ReportSupplemental (standard reports)
    readonly reportDAC?: string | undefined;
    readonly reportDTL?: string | undefined;
    readonly reportDTLP?: string | undefined;
    readonly reportDTTL?: string | undefined;
    readonly reportPCL?: string | undefined;
};

const ReportHeader: React.FC<TReportHeaderProps> = ({
    header,
    reportTypeCode,
    reportNumber,
    primaryCTA,
    labels,
    reportDAC,
    reportDTL,
    reportDTLP,
    reportDTTL,
    reportPCL,
}) => {
    // Determine if this is a structured/jewelry report (uses ReportSupplementals)
    // vs a standard report (uses ReportSupplemental)
    const isStructuredOrJewelry = ['LGQA', 'QAD', 'QADLG', 'JG', 'JGC'].includes(reportTypeCode);

    return (
        <div className='flex flex-wrap'>
            <div className='flex-1'>
                <div className='flex flex-col lg:flex-row lg:items-start lg:justify-between'>
                    {/* Always show ReportBasicInfo */}
                    <ReportBasicInfo reportNumber={header.REPORT_NO} reportDate={header.REPORT_DT} />

                    {/* Conditional Supplemental Components */}
                    {isStructuredOrJewelry ? (
                        /* ReportSupplementals for structured/jewelry reports */
                        <ReportSupplementals header={header} />
                    ) : (
                        /* ReportSupplemental for standard reports */
                        <div className='hidden md:ml-auto md:block md:w-1/4 md:min-w-60'>
                            <ReportSupplemental
                                reportTypeCode={reportTypeCode}
                                reportNumber={reportNumber}
                                primaryCTA={primaryCTA}
                                reportDAC={reportDAC ?? ''}
                                reportDTL={reportDTL ?? ''}
                                reportDTLP={reportDTLP ?? ''}
                                reportDTTL={reportDTTL ?? ''}
                                reportPCL={reportPCL ?? ''}
                                i18n={labels.legacy}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export type { TReportHeaderProps };
export default ReportHeader;
